/*
 * PrivacyBadge — minimalistic "Private & encrypted" indicator.
 *
 * Placed near main text inputs (scene analysis, Leo chat, Career Path)
 * to remind the actor that their content is stored encrypted at rest.
 * Pure display component — no popover, no walkthrough.
 * Inter 500 (inherited), gold accent, discreet.
 */

import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function PrivacyBadge({ className = "" }) {
  const { lang } = useAuth();
  const label = lang === "en" ? "Private & encrypted" : "Prywatne i zaszyfrowane";
  return (
    <span
      data-testid="privacy-badge"
      className={
        "inline-flex items-center gap-1.5 text-[10.5px] tracking-[.18em] uppercase " +
        "text-amber-400/70 font-medium select-none " + className
      }
      title={label}
    >
      <Lock size={10} className="opacity-80" strokeWidth={2.5} />
      <span>{label}</span>
    </span>
  );
}
